var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.4C18 10.12 17.37 10.75 16.65 10.75H11.7L7.2 17.95H5.4L7.65 10.75H2.7L1.35 12.55H0L0.9 9.4L0 6.25H1.35L2.7 8.05H7.65L5.4 0.850004H7.2L11.7 8.05H16.65C17.37 8.05 18 8.68 18 9.4Z",
    fill: "#0064D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlights);
export default __webpack_public_path__ + "static/media/flights.bb1a436d6194a937923b3b68ff569eb7.svg";
export { ForwardRef as ReactComponent };